import script from "./GlobalFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalFooter.vue?vue&type=script&setup=true&lang=ts"

import "./GlobalFooter.vue?vue&type=style&index=0&id=7e9ff0f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e9ff0f8"]])

export default __exports__